import { HttpClient } from "@angular/common/http";
import { Component, Input, OnChanges, OnInit } from "@angular/core";
import {
  ControlContainer,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  UntypedFormArray,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "@environments/environment";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { faTrash, faEdit } from "@fortawesome/pro-solid-svg-icons";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { ConfigureThresholdsComponent } from "@dialogs/configure-thresholds/configure-thresholds.component";
import { ConfigureThresholdsTableComponent } from "@dialogs/configure-thresholds-table/configure-thresholds-table.component";

@Component({
    selector: "app-coloring",
    templateUrl: "./coloring.component.html",
    styleUrls: ["./coloring.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class ColoringComponent implements OnInit, OnChanges {
  constructor(
    public parentF: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    public commonService: CommonService,
    private canvasService: CanvasService,
    public dialog: MatDialog
  ) {}
  @Input() chartType!: any;
  @Input() manualChartColors!: any;
  @Input() isComponentOpen!: any;
  @Input() currentDataFields!: any;
  @Input() visibleDataPoints!: any;
  @Input() appliedSeries!: any;

  public fieldForm!: UntypedFormGroup;
  public childForm: any;
  public aggregateData: any = [];
  public loadedColors = false;
  public colorForm!: UntypedFormGroup;
  public thresholdForm!: UntypedFormGroup;
  public thresholdFields: any[] = [];
  public filteredDataFields: any[] = [];
  public colorPickerControls: any = ["no-alpha"];
  public featureFlags: any = sessionStorage.getItem("featureFlags");

  field: any;
  auto: any;
  color: any;
  fieldData: any;
  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  name: string = "";
  type: string = "";
  public formFields: any[] = [];
  faExclamationTriangle = faExclamationTriangle;
  faPlus = faPlus;

  faEdit = faEdit;
  faTrash = faTrash;
  thresholdDefault = "";
  selectedIndex = -1;
  colorFormGenerated = false;

  generateColors(index: number) {
    if (this.loadedColors && this.isComponentOpen) {
      setTimeout(() => {
        let colorField: any = null;
        colorField = this.colorForm.get("color" + index);
        if (colorField!.pristine) {
        } else {
          let field = this.manualChartColors[index];
          field.color = colorField!.value;
          this.aggregateData = this.manualChartColors;

          this.canvasService.refreshCanvas(this.childForm).subscribe(
            (success: any) => {
              this.canvasService.triggerEnable();
              const data = success.data;
              this.canvasService.pushChartToStorage(data);
              this.canvasService.populateCanvas(data);
              colorField.markAsPristine();
            },
            (error: any) => {
              this.canvasService.triggerEnable();
              const data = this.canvasService.getChartFromStorage();
              this.canvasService.populateCanvas(data);
            }
          );
        }
      });
    }
  }

  selectField(condition: boolean, fieldID: any) {
    if (condition) {
      this.selectedIndex = fieldID;
    } else {
      this.selectedIndex = -1;
    }
  }
  createItem(conditionVal?: string): UntypedFormGroup {
    if (conditionVal) {
      return this.fb.group({
        condition: [conditionVal],
      });
    } else {
      return this.fb.group({
        condition: ["and"],
      });
    }
  }

  addItem(conditionVal?: string): void {
    if (this.fieldForm) {
      let condition = this.fieldForm.get("conditions") as UntypedFormArray;
      if (conditionVal) {
        condition.push(this.createItem(conditionVal));
      } else {
        condition.push(this.createItem());
      }
    }
  }
  deleteItem(idx: number) {
    let condition = this.fieldForm.get("conditions") as UntypedFormArray;
    condition.removeAt(idx);
    // this.canvasService
    //   .refreshCanvas(this.childForm)
    //   .subscribe((success: any) => {
    //     if (success) {
    //       const data = success.data;
    //       this.canvasService.populateCanvas(data);
    //     }
    //   });
  }

  addThreshold() {
    let selected = this.fieldForm.get("selectItem")!.value;
    const itemtoMove = this.currentDataFields.filter((item: any) => {
      return item.id == selected;
    });

    if (itemtoMove[0]) {
      this.thresholdFields.push(itemtoMove[0]);
      this.addItem();
      setTimeout(() => {
        this.configureFilter(
          null,
          this.thresholdFields.length - 1,
          this.thresholdFields[this.thresholdFields.length - 1].id,
          this.thresholdFields[this.thresholdFields.length - 1],
          true
        );
      }, 100);
      // this.buildAggregateData();
      this.fieldForm.get("selectItem")!.setValue("");
    }
  }

  addThresholdsFromInit(element: any, array: any) {
    let selected = element.dataPointId;
    const itemtoMove = this.currentDataFields.filter((item: any) => {
      if (!this.isInCurrentThresholdList(item.id)) return item.id == selected;
      else return null;
    });

    const colorsForThisField = array.filter((item: any) => {
      return item.dataPointId == selected;
    });

    if (itemtoMove[0]) {
      itemtoMove[0].dynamicChartColors = colorsForThisField;
      this.thresholdFields.push(itemtoMove[0]);
      this.addItemFromInit();
    }
  }

  createItemFromInit(conditionVal?: string): UntypedFormGroup {
    if (conditionVal) {
      return this.fb.group({
        condition: [conditionVal],
      });
    } else {
      return this.fb.group({
        condition: ["and"],
      });
    }
  }

  addItemFromInit(conditionVal?: string): void {
    if (this.fieldForm) {
      let condition = this.fieldForm.get("conditions") as UntypedFormArray;
      if (conditionVal) {
        condition.push(this.createItem(conditionVal));
      } else {
        condition.push(this.createItem());
      }
    }
  }

  isInCurrentThresholdList(id: any) {
    let found = false;
    const field = this.thresholdFields.find((x: any) => x.id === id);
    if (field) found = true;
    return found;
  }
  choosePlaceholder() {
    let placeholder = "Choose Field to Configure";

    if (this.filteredDataFields.length == this.thresholdFields.length)
      placeholder = "All Available Fields Added";

    return placeholder;
  }
  disableSelect() {
    if (this.filteredDataFields.length == this.thresholdFields.length)
      this.fieldForm.get("selectItem")?.disable();
    else this.fieldForm.get("selectItem")?.enable();
  }
  generateColorForm() {
    this.colorForm.reset();
    if (this.manualChartColors) {
      let forEachPromise = new Promise<void>((resolve) => {
        this.manualChartColors.forEach((field: any, index: any, array: any) => {
          this.colorForm.addControl(
            "color" + index,
            this.fb.control(field.color)
          );
          if (index === array.length - 1) resolve();
        });
      });
      forEachPromise.then(() => {
        setTimeout(() => {
          this.loadedColors = true;
        }, 10);
      });
    }
    this.loadedColors = true;
  }

  configureFilter(
    event: any,
    index: number,
    id: number,
    field: any,
    auto: boolean
  ) {
    if (event) event.stopPropagation();

    this.selectField(true, index);
    const elem = "colorRight-" + index;
    const element = document.getElementById(elem);
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    let dialogRef: any = this.dialog;

    if (rect.top == 0) {
      if (this.chartType != "Table" && this.chartType != "List") {
        dialogRef = this.dialog.open(ConfigureThresholdsComponent, {
          width: "1000px",
          disableClose: true,
          data: {
            id: id,
            field: field,
            auto: auto,
          },
          panelClass: "canvas-dialog",
        });
      } else {
        dialogRef = this.dialog.open(ConfigureThresholdsTableComponent, {
          width: "1100px",
          disableClose: true,
          data: {
            id: id,
            field: field,
            auto: auto,
          },
          panelClass: "canvas-dialog",
        });
      }
    } else {
      if (this.chartType != "Table" && this.chartType != "List") {
        dialogRef = this.dialog.open(ConfigureThresholdsComponent, {
          width: "900px",
          disableClose: true,
          data: {
            id: id,
            field: field,
            auto: auto,
            chartType: this.chartType,
          },
          panelClass: ["canvas-dialog"],
        });
      } else {
        dialogRef = this.dialog.open(ConfigureThresholdsTableComponent, {
          width: "1000px",
          disableClose: true,
          data: {
            id: id,
            field: field,
            auto: auto,
            chartType: this.chartType,
          },
          panelClass: ["canvas-dialog"],
        });
      }
    }

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.thresholdFields[index].dynamicChartColors = result.items;

        let colorArray: any[] = [];

        let dynamicChartColors =
          this.childForm.controls["dynamicChartColors"].value;

        if (dynamicChartColors) {
          dynamicChartColors.forEach((item: any) => {
            let data;
            if (this.chartType != "Table" && this.chartType != "List") {
              data = {
                color: item.color,
                dataPointId: item.dataPointId,
                value: item.value,
                valueEnd: item.valueEnd,
              };
            } else {
              data = {
                color: item.color,
                dataPointId: item.dataPointId,
                value: item.value,
                textColor: item.textColor,
              };
            }

            colorArray.push(data);
          });
        }

        colorArray = colorArray.filter((item: any) => item.dataPointId !== id);

        let lowestValue = 999999;

        result.items.forEach((item: any) => {
          let data;
          if (this.chartType != "Table" && this.chartType != "List") {
            data = {
              color: item.color,
              dataPointId: item.dataPointId,
              value: item.value,
              valueEnd: item.valueEnd,
            };
            if (item.value <= lowestValue) lowestValue = item.value;
          } else {
            data = {
              color: item.color,
              dataPointId: item.dataPointId,
              value: item.value,
              textColor: item.textColor,
            };
          }
          const found = colorArray.find(
            (el) =>
              el.dataPointId === item.dataPointId &&
              el.value === item.value &&
              el.valueEnd === item.valueEnd
          );

          if (!found) {
            colorArray.push(data);
          } else {
            const findIndex = colorArray.findIndex(
              (el) =>
                el.dataPointId === item.dataPointId &&
                el.value === item.value &&
                el.valueEnd === item.valueEnd
            );
            colorArray[findIndex] = data;
          }
        });

        // if (this.chartType != "Table") {
        //   const defaultData = {
        //     color: this.manualChartColors[0].color,
        //     dataPointId: result.items[0].dataPointId,
        //     value: -999999,
        //     valueEnd: lowestValue,
        //   };
        //   colorArray.unshift(defaultData);
        // }

        let uniqueColorArray = [...new Set(colorArray)];

        this.childForm.controls["dynamicChartColors"].setValue(
          uniqueColorArray
        );
        this.childForm.controls["colorType"].setValue(
          this.thresholdForm.get("threshold")!.value
        );
        this.selectField(false, index);
        this.buildAggregateData();
      } else {
        if (auto) this.removeDataField(null, this.thresholdFields.length - 1);
        else this.selectField(false, index);
      }
    });
  }

  removeDataField(event: any, index: number) {
    const elem = "colorRight-" + index;
    const element = document.getElementById(elem);
    let messageDetail = "";
    this.selectField(true, index);
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    if (event) {
      event.stopPropagation();
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: "Remove this threshold?",
          messageDetail: messageDetail,
          actionButton: "remove",
        },
        panelClass: ["canvas-dialog", "dialog-right"],
        position: { top: rect.top - 50 + "px", left: rect.left - 380 + "px" },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.selectField(false, index);
        if (result) {
          this.thresholdFields[index].dynamicChartColors = null;
          this.thresholdFields.splice(index, 1);
          this.deleteItem(index);

          let colorArray: any[] = [];

          this.thresholdFields.forEach((datapoint: any) => {
            datapoint.dynamicChartColors.forEach((item: any) => {
              colorArray.push(item);
            });
          });

          this.childForm.controls["dynamicChartColors"].setValue(colorArray);

          this.buildAggregateData();
        }
      });
    } else {
      this.thresholdFields.splice(index, 1);
      if (this.thresholdFields.length <= 0) {
        this.childForm.controls["collection"].setValue(null);
      }
      //this.buildAggregateData();
    }
  }

  buildAggregateData() {
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        this.canvasService.populateCanvas(data);
        this.disableSelect();
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        this.canvasService.populateCanvas(data);
      }
    );
  }

  initForm() {
    this.childForm = this.parentF.form;
    this.colorForm = this.fb.group({});

    this.loadedColors = false;

    let filteredDataFields: any = [];

    if (this.chartType.toLowerCase() == "table") {
      const visible = this.commonService.generateVisualDataPoints(
        this.visibleDataPoints
      );
      this.currentDataFields.forEach((element: any) => {
        if (visible.indexOf(element.id) != -1) {
          filteredDataFields.push(element);
        }
      });
      this.filteredDataFields = filteredDataFields;
    } else {
      const series = this.commonService.generateVisualDataPoints(
        this.appliedSeries
      );

      this.currentDataFields.forEach((element: any) => {
        if (series.indexOf(element.id) != -1) {
          filteredDataFields.push(element);
        }
      });
      this.filteredDataFields = filteredDataFields;
    }

    const colorType = this.childForm.get("colorType").value || "";

    if (this.chartType == "Table" || this.chartType == "List") {
      this.thresholdDefault = "dynamic";
    } else {
      this.thresholdDefault = colorType;
    }

    if (this.chartType == "Pie") {
      this.childForm.get("colorType").setValue("manual");
      this.thresholdDefault = "manual";
    }
    let dynamicChartColors = [];
    if (this.childForm && this.childForm.get("dynamicChartColors")) {
      dynamicChartColors = this.childForm.get("dynamicChartColors").value || [];
      this.thresholdFields = [];
      if (dynamicChartColors) this.populateThresholds(dynamicChartColors);
    }
    //this.thresholdFields = [];
    if (colorType) this.thresholdDefault = colorType;
    this.thresholdForm = this.fb.group({
      threshold: new UntypedFormControl(this.thresholdDefault),
    });
    this.generateColorForm();
  }

  populateThresholds(array: any) {
    if (array && array.length > 0)
      array.forEach((item: any) => {
        this.addThresholdsFromInit(item, array);
      });
  }

  ngOnChanges(): void {
    if (this.isComponentOpen) this.initForm();

    setTimeout(() => {
      this.disableSelect();
    }, 100);
  }

  ngOnInit(): void {
    this.initForm();
    setTimeout(() => {
      this.colorFormGenerated = true;
    }, 100);
    this.fieldForm = this.fb.group({
      selectItem: new UntypedFormControl(""),
      field: new UntypedFormControl(""),
      conditions: this.fb.array([]),
    });
    this.disableSelect();
  }
}
